import React, { useState, useEffect } from 'react';

function ElapsedTime({ startDate }) {
  const [elapsedTime, setElapsedTime] = useState('');

  // Calculate elapsed time from start date in HH:MM:SS format
  const calculateElapsedTime = () => {
    if (!startDate) return '';
    
    const startTime = new Date(startDate);
    const currentTime = new Date();
    const diffInSeconds = Math.floor((currentTime - startTime) / 1000);
    
    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;
    
    // Format as HH:MM:SS
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  // Update elapsed time every second
  useEffect(() => {
    if (!startDate) return;
    
    const updateElapsedTime = () => {
      setElapsedTime(calculateElapsedTime());
    };
    
    // Update immediately
    updateElapsedTime();
    
    // Update every second
    const interval = setInterval(updateElapsedTime, 1000);
    
    return () => clearInterval(interval);
  }, [startDate]);

  // Don't render if no start date
  if (!startDate) return null;

  return (
    <div>
      <h3 className="text-lg font-bold text-gray-900 mb-3">
        Elapsed Time
      </h3>
      <div className="text-xl font-regular text-gray-900 font-mono">
        {elapsedTime}
      </div>
    </div>
  );
}

export default ElapsedTime;
